import React,{useState,useEffect} from "react";
import Select from "react-select";
import {
    TerritoryOptions
  } from "../../../Constants/brand";
const EditIntroducerModal = ({onSave,initialValues})=>{
    let [profile,updateProfile] = useState({user_name:"",user_password:"",user_email:"",user_territory:{value:"UK",label:"UK"},
    user_sales:0,user_revenue:0,user_cashback:0,user_ecoAds:0});
    useEffect(()=>{
        let newUser = {...initialValues};
        if(newUser){
            delete newUser['id'];
            const {user_territory} = newUser;
            // let newUser = initialValues;
            newUser["user_territory"] = {value:user_territory,label:user_territory};
            updateProfile({...newUser});
        }
        
    },[initialValues])
   
    
    const onChangeHandler = (e)=>{
        let newProfile = profile;
        newProfile[e.target.name] = e.target.value;
        updateProfile({...newProfile});
    }
    const handleTerritoryOptions = (value)=>{
        let newProfile = profile;
        newProfile["user_territory"] =  value;
        updateProfile({...newProfile});
    }
    const onEditIntroducer = ()=>{
        profile.user_territory = profile.user_territory.value;
        onSave(profile);
    }
    return (
      <div
        className="modal fade"
        id="edit_introducer"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Introducer</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <label htmlFor="user_sales">FirstName</label>
                <input
                  type="text"
                  className="form-control form-control-md"
                  name="user_name"
                  placeholder="First Name"
                  onChange={onChangeHandler}
                  value={profile.user_name}
                />
              </div>
              <div className="form-group">
                <label htmlFor="user_sales">Email</label>
                <input
                  type="text"
                  className="form-control form-control-md"
                  placeholder="Email"
                  name="user_email"
                  onChange={onChangeHandler}
                  value={profile.user_email}
                />
              </div>
              <div className="form-group">
                <label htmlFor="user_sales">Password</label>
                <input
                  type="text"
                  className="form-control form-control-md"
                  placeholder="Password"
                  name="user_password"
                  onChange={onChangeHandler}
                  value={profile.user_password}
                />
              </div>
              <div className="form-group">
                <label htmlFor="user_sales">Territory</label>
                <Select
                    value={profile.user_territory}
                    name="user_territory"
                    onChange={handleTerritoryOptions}
                    options={TerritoryOptions}
                />
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                    <label htmlFor="user_sales">Sales</label>
                    <input
                    type="number"
                    className="form-control form-control-md"
                    placeholder="Sales"
                    name="user_sales"
                    onChange={onChangeHandler}
                    value={profile.user_sales}
                    />
                </div>
                <div className="form-group col-md-6">
                    <label htmlFor="user_revenue">% on revenue</label>
                    <input
                    type="number"
                    className="form-control form-control-md"
                    placeholder="% on revenue"
                    name="user_revenue"
                    onChange={onChangeHandler}
                    value={profile.user_revenue}
                    />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                    <label htmlFor="user_cashback">% on Cashback</label>
                    <input
                    type="number"
                    className="form-control form-control-md"
                    placeholder="% on Cashback"
                    name="user_cashback"
                    onChange={onChangeHandler}
                    value={profile.user_cashback}
                    />
                </div>
                <div className="form-group col-md-6">
                    <label htmlFor="user_ecoAds">% on EcoAds</label>
                    <input
                    type="number"
                    className="form-control form-control-md"
                    placeholder="% on EcoAds"
                    name="user_ecoAds"
                    onChange={onChangeHandler}
                    value={profile.user_ecoAds}
                    />
                </div>
              </div>
              
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-orange"
                data-dismiss="modal"
              >
                Later
              </button>
              <button
                type="button"
                className="btn btn-green"
                data-dismiss="modal"
                onClick={onEditIntroducer}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    );
}
export default EditIntroducerModal;



// WEBPACK FOOTER //
// ./src/screens/Introducer/components/EditIntroducerModal.js